<template>
  <div v-show="show">
    <input class="form-control mb-3" placeholder="Pesquisar Emoji" v-model="term" type="search">
    <div class="container-cats border-bottom">
      <a href="javascript:" class="text-secondary text-decoration-none cat"
         :class="{'selected': category === index}"
         v-for="(c, index) in categories"
         @click="selCategory(c, index)">
        <i :class="c.icon"></i>
      </a>
    </div>
    <div class="container-emojis border-bottom">
      <div v-for="(c, index) in filteredCategories" :key="index">
        <div :id="`category${index}`" class="py-1">{{c.name || 'Recentes'}}</div>
        <div class="categories-emojis mb-3">
          <a href="javascript:" class="text-decoration-none sel" v-for="e in c.emojis"
             @click="selEmoji(e)">
            {{e.emoji}}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import json from '../db/emoji.json'
export default {
  name: "ListEmojis",
  data() {
    return {
      show: false,
      term: '',
      json: json,
      emojis: [],
      recentes: [],
      category: '',
      categories: [
        { name: '', icon: 'far fa-clock', emojis: [] },
        { name: 'Smileys & Emotion', nome: '', icon: 'far fa-smile', emojis: [] },
        { name: 'People & Body', icon: 'fas fa-thumbs-up', emojis: [] },
        { name: 'Animals & Nature', icon: 'fas fa-tree', emojis: [] },
        { name: 'Food & Drink', icon: 'fas fa-coffee', emojis: [] },
        { name: 'Travel & Places', icon: 'fas fa-car', emojis: [] },
        { name: 'Activities', icon: 'fas fa-futbol', emojis: [] },
        { name: 'Objects', icon: 'fas fa-wrench', emojis: [] },
        { name: 'Symbols', icon: 'far fa-heart', emojis: [] },
        { name: 'Flags', icon: 'far fa-flag', emojis: [] }
      ]
    }
  },

  methods: {
    selCategory(c, index) {
      this.category = index;
      this.$helpers.scrollView(`category${index}`);
    },

    selEmoji(e) {
      this.recentes = this.recentes.filter(r => r.emoji !== e.emoji);
      this.recentes.unshift({ ...e, recente: true });
      localStorage.setItem('rEmojis', JSON.stringify(this.recentes.slice(0, 10)));
      this.$emit('addEmoji', e.emoji);
    }
  },

  mounted() {
    this.recentes = JSON.parse(localStorage.getItem('rEmojis') || '[]');
    this.categories.forEach(c => {
      c.emojis = c.name ? this.json.filter(j => j.category === c.name) : this.recentes;
    });
  },

  created() {
    this.$parent.$on('toggleEmoji', (close) => {
      this.term = '';
      this.show = close ? false : !this.show;
      this.categories[0].emojis = this.recentes;
      this.category = 0;
    });
  },

  computed: {
    filteredCategories() {
      if (!this.term) return this.categories;

      const term = this.term.toLowerCase().trim();

      const results = this.json.filter(e => {
        const descriptionMatch = (e.description || '').toLowerCase().includes(term);
        const aliasMatch = (e.aliases || []).some(a => a.toLowerCase().includes(term));
        const tagMatch = (e.tags || []).some(t => t.toLowerCase().includes(term));
        return descriptionMatch || aliasMatch || tagMatch;
      });

      return [{
        name: 'Resultados',
        icon: '',
        emojis: results
      }];
    }
  }
}
</script>

<style scoped>
.container-cats {
  display: flex;
  justify-content: space-between;
  padding-bottom: 6px;
}
.cat {
  display: block;
  width: 100%;
  height: 32px;
  font-size: 18px;
  text-align: center;
}
.cat.selected {
  border-bottom: 2px solid var(--success);
  color: var(--success)!important;
}
.sel {
  font-size: 24px;
  width: 32px;
  height: 32px;
}
.container-emojis {
  height: 30vh;
  overflow: auto;
  padding-top: 8px;
  margin-bottom: 12px;
}
.categories-emojis {
  text-align: center;
  display: flex;
  flex-wrap: wrap;
}
</style>